import * as React from "react";
import { Text } from "../../../ui/components/Text";
import { Modal } from "../../../ui/components/Modal";
import { Callout } from "../../../ui/components/Callout";
import { EmailSetupStep } from "../user-setup/EmailSetupStep";
import { useEmailVerification } from "./useEmailVerification";

export interface VerifyEmailModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  onClose?: () => void;
}

export function VerifyEmailModal({ open, setOpen, onClose }: VerifyEmailModalProps) {
  const emailVerification = useEmailVerification({ active: open, requestOnOpen: false });
  const wasOpenRef = React.useRef(false);

  React.useEffect(() => {
    if (wasOpenRef.current && !open) {
      onClose?.();
    }
    wasOpenRef.current = open;
  }, [open, onClose]);

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      minWidth="520px"
      maxWidth="520px"
      minHeight="auto"
      maxHeight="85vh"
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 16,
          padding: "8px 4px 4px",
        }}
      >
        <Text level="h3" weight="bold">
          Verify your email
        </Text>

        {emailVerification.sectionError && (
          <Callout variant="error">{emailVerification.sectionError}</Callout>
        )}

        <EmailSetupStep
          standalone
          user={emailVerification.user}
          search={emailVerification.search}
          displayEmail={emailVerification.displayEmail}
          verifyStatus={emailVerification.verifyStatus}
          verifyMessage={emailVerification.verifyMessage}
          resendLoading={emailVerification.resendLoading}
          onResendEmail={emailVerification.handleResendEmail}
          onManualCodeVerify={emailVerification.handleManualCodeVerify}
          onClearVerification={emailVerification.clearEmailVerificationState}
        />
      </div>
    </Modal>
  );
}
